import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import TopNavbar from './TopNavbar';
import MainNavbar from './MainNavbar';

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const isHomepage = location.pathname === '/';
  
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  
  // This logic determines the background for the ENTIRE header block
  const headerBgClass = !isHomepage || scrolled 
    ? 'bg-white shadow-md dark:bg-gray-900' 
    : 'bg-transparent';

  return (
    // This header is now the single sticky element. It has the highest z-index.
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${headerBgClass}`}>
      <TopNavbar />
      <MainNavbar scrolled={scrolled} />
    </header>
  );
}